import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = { class: "app-company-status-dialog--content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: "/img/home/clock.svg" }, null, -1)
const _hoisted_4 = { class: "app-company-status-dialog--content-heading" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "app-company-status-dialog--content-description" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"visibility":"hidden"} }, " Coming Soon Coming Soon Coming Soon Coming ")
], -1)
const _hoisted_6 = {
  key: 1,
  class: "app-company-status-dialog--content-heading"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: "/img/home/clock.svg" }, null, -1)
const _hoisted_8 = { class: "app-company-status-dialog--content-heading" }
const _hoisted_9 = { class: "app-company-status-dialog--content-description" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: "/img/home/company-details.svg" }, null, -1)
const _hoisted_11 = { class: "app-company-status-dialog--content-heading" }
const _hoisted_12 = {
  key: 4,
  class: "app-company-status-dialog--content-heading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_p_button = _resolveComponent("p-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_p_dialog = _resolveComponent("p-dialog")!

  return (_openBlock(), _createBlock(_component_p_dialog, {
    visible: false,
    "onUpdate:visible": _ctx.toggle,
    modal: "",
    dismissableMask: "",
    class: "app-company-status-dialog"
  }, _createSlots({
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.model.showCompanyStatusModal === 'comingSoon')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_i18n_t, { keypath: "common.comingSoon" })
              ]),
              _hoisted_5
            ], 64))
          : (
                    _ctx.currentCompany.companyDto?.status.id === _ctx.enumCompanyRole.DEACTIVATED
                )
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_i18n_t, { keypath: "companyStatusPopup.declined" })
              ]))
            : (
                    _ctx.currentCompany.companyDto?.status.id ===
                    _ctx.enumCompanyRole.AWAITING_APPROVAL
                )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_i18n_t, { keypath: "companyStatusPopup.in_progress" })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_i18n_t, { keypath: "companyStatusPopup.in_progress_description" })
                  ])
                ], 64))
              : (_ctx.model.isAwaitingAccountConfirmation)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_i18n_t, { keypath: "companyStatusPopup.welcome_description" })
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_ctx.model.isLimitedAdmin)
                      ? (_openBlock(), _createBlock(_component_i18n_t, {
                          key: 0,
                          keypath: "companyStatusPopup.limited_admin_description"
                        }))
                      : (_ctx.model.showCompanyStatusModal === 'default')
                        ? (_openBlock(), _createBlock(_component_i18n_t, {
                            key: 1,
                            keypath: "companyStatusPopup.description"
                          }))
                        : (_ctx.model.showCompanyStatusModal === 'welcome')
                          ? (_openBlock(), _createBlock(_component_i18n_t, {
                              key: 2,
                              keypath: "companyStatusPopup.welcome_description"
                            }))
                          : _createCommentVNode("", true)
                  ]))
      ])
    ]),
    _: 2
  }, [
    (_ctx.model.showCompanyStatusModal !== 'comingSoon')
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/auth/my-carconnex/my-account/company-info" }, {
              default: _withCtx(({ navigate }) => [
                _createVNode(_component_p_button, {
                  onClick: 
                        () => {
                            navigate();
                            _ctx.model.showCompanyStatusModal = false;
                        }
                    ,
                  class: "p-text-uppercase",
                  label: _ctx.i18n.t('companyStatusPopup.button'),
                  autofocus: ""
                }, null, 8, ["onClick", "label"])
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["onUpdate:visible"]))
}